/**
 * Give — Mission / giving page for Twin City Silver Bullet (F-015, T-003).
 *
 * Static content mirroring the live site's "Our Mission / Why We Roll" copy:
 * the truck is run by the Twin City Veterans Bridge nonprofit, and proceeds
 * support transitioning veterans. Links out to the veterans nonprofit
 * (PRJ-001 §3 #11). Styled per BLU-006.
 *
 * SPR-018 C-02: the call-to-action is a "Donate" button that navigates to the
 * in-app /donate placeholder page (formerly a "Notify Me" stub in the prototype).
 */
import { Link } from "react-router-dom";

export default function Give() {
  return (
    <main data-testid="give-page" className="min-h-screen bg-cream text-ink font-body">
      <section className="max-w-3xl mx-auto px-4 py-16">
        <p className="font-heading tracking-[0.3em] text-teal-deep text-sm">WHY WE ROLL</p>
        <h1 className="font-display text-5xl text-charcoal uppercase mb-6">Our Mission</h1>

        <p className="font-display text-3xl text-rust uppercase mb-8">
          Every cup helps build a bridge home.
        </p>

        <div className="space-y-5 font-body text-ink/80 text-lg leading-relaxed">
          <p>
            Twin City Silver Bullet is run by <strong>Twin City Veterans Bridge</strong>, a
            nonprofit helping transitioning veterans build careers, ventures, and a place in this
            community.
          </p>
          <p>
            We partner with <strong>Veterans Helping Veterans Heal (VHVH)</strong> to help veterans
            rebuild their footing — and the profit from every coffee and every scoop goes back to
            that mission.
          </p>
          <p>
            A polished 1967 Airstream, towed by a 1979 International Scout II, built and run by the
            people it serves. Every order keeps the Bullet rolling and a veteran moving forward.
          </p>
        </div>

        {/* Callout — nonprofit link */}
        <div className="mt-10 bg-cream-deep border-2 border-dashed border-aluminum-dark rounded-2xl p-6">
          <h2 className="font-display text-2xl text-charcoal uppercase mb-2">Support the Mission</h2>
          <p className="font-body text-ink/70 mb-5">
            Learn more about the nonprofit behind the Bullet and how your support builds a bridge
            home for transitioning veterans.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/donate"
              className="inline-block bg-rust text-white font-heading text-lg tracking-widest px-7 py-3 rounded-xl shadow-[0_4px_0_#7f371e] hover:translate-y-0.5 hover:shadow-[0_2px_0_#7f371e] transition-all"
              data-testid="give-donate-link"
            >
              DONATE
            </Link>
            <a
              href="https://twincityveterans.org"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-cream text-charcoal font-heading text-lg tracking-widest px-7 py-3 rounded-xl border-2 border-charcoal/20 hover:border-teal hover:text-teal transition-all"
              data-testid="give-nonprofit-link"
            >
              VISIT TWIN CITY VETERANS BRIDGE
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
